import { makeAutoObservable } from "mobx";
import { AttributeShelf } from "../../shelves";

export class PreSimulationStore {
	public balance = new AttributeShelf(3166.83);
	public birthMonth = new AttributeShelf(9);

	constructor() {
		makeAutoObservable(this);
	}
}
